import { LRParser } from '@lezer/lr';
import { LRLanguage, LanguageSupport } from '@codemirror/language';
import { styleTags, tags } from '@lezer/highlight';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const parser = LRParser.deserialize({
  version: 14,
  states: "!WQVQPOOO_QPO'#CbOOQO'#Cf'#CfOOQO'#Cc'#CcQVQPOOOOQO,58|,58|OjQPO,58|OOQO-E6a-E6aOOQO1G.h1G.h",
  stateData: "u~OPOS~ORQOTPO~ORQOSTOTPO~ORQOSWOTPO~O",
  goto: "rZPPPPPP[bPPlXQOPSUQSOQUPTVSUXROPSU",
  nodeNames: "⚠ Comment Program Operator ] [ Loop",
  maxTerm: 10,
  nodeProps: [
    ["openedBy", 4,"["],
    ["closedBy", 5,"]"]
  ],
  skippedNodes: [0,1],
  repeatNodeCount: 1,
  tokenData: "!u~R^O{}{|!f|}!f}!O!f!O!P!f!P!^}!^!_!f!_!`}!`!a!f!a!}}!}#O!k#O#P}#P#Q!p#Q~}~!SUP~O{}!P!^}!_!`}!a!}}#O#P}#Q~}~!kOR~~!pOT~~!uOS~",
  tokenizers: [0],
  topRules: {"Program":[0,2]},
  tokenPrec: 0
});

const brainfuckLanguage = LRLanguage.define({
    parser: parser.configure({
        props: [
            styleTags({
                "[ ]": tags.squareBracket,
                Comment: tags.comment,
                Operator: tags.operator,
            })
        ]
    }),
    languageData: {
        // Prevent auto insertion of closing brackets for `({'"`.
        closeBrackets: { brackets: ["["] }
    }
});
function brainfuck() {
    return new LanguageSupport(brainfuckLanguage);
}

export { brainfuck, brainfuckLanguage };
